import React from 'react'
import PropTypes from 'prop-types'
import InputWrapper from './InputWrapper'
import { Select } from 'antd'

const { Option } = Select

const SelectInput = ({
  name,
  label,
  formItemOptions = {},
  options = [],
  ...rest
}) => {
  return (
    <InputWrapper
      name={name}
      label={label}
      {...formItemOptions}
      eventValueGetter={(value) => value}
    >
      <Select {...rest}>
        {options.map(({ label, value, desc }) => (
          <Option key={value} value={value} label={label}>
            {desc ? (
              <div>
                {label}
                <span style={{ color: '#c4c4c4', marginLeft: 10 }}>
                  ({desc})
                </span>
              </div>
            ) : (
              <div>{label}</div>
            )}
          </Option>
        ))}
      </Select>
    </InputWrapper>
  )
}

SelectInput.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  formItemOptions: PropTypes.object,
  options: PropTypes.array,
}

export default SelectInput
